/**
 * Màu theo hộ trên bản đồ chung: cùng hộ cùng màu, khác hộ khác màu.
 *
 * Chọn màu bằng hash id hộ chứ không đánh số theo thứ tự tải: lazy-load theo ô
 * nên thứ tự hộ xuất hiện đổi theo cách người dùng pan — đánh số là cùng một
 * hộ mỗi lần mở một màu. Hash ổn định → hộ nào cũng giữ màu của mình mãi.
 *
 * 12 màu đủ tương phản trên nền ảnh vệ tinh (xanh lá/nâu đất): tránh xanh lá
 * đậm và nâu. Trên 12 hộ trong cùng khung nhìn thì bắt đầu trùng màu — chấp
 * nhận, nhãn "tên hộ" vẫn phân biệt được.
 */
export const GROWER_PALETTE = [
    '#ef4444', // red
    '#f97316', // orange
    '#eab308', // yellow
    '#06b6d4', // cyan
    '#3b82f6', // blue
    '#8b5cf6', // violet
    '#ec4899', // pink
    '#14b8a6', // teal
    '#f43f5e', // rose
    '#a855f7', // purple
    '#0ea5e9', // sky
    '#fb7185', // light rose
] as const

/** FNV-1a 32-bit: rẻ, phân bố đều cho chuỗi UUID, không cần crypto. */
export function hashString(s: string): number {
    let h = 0x811c9dc5
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i)
        h = Math.imul(h, 0x01000193)
    }
    return h >>> 0
}

export function colorForGrower(growerId: string): string {
    return GROWER_PALETTE[hashString(growerId) % GROWER_PALETTE.length]
}
